import apiClient from "./apiClient";

export const getAllChats = () => {
	return apiClient.get("/Chat/GetAllChats");
};

export const getMessagesByPhone = (phone) => {
	return apiClient.get(`/Chat/GetMessagesByPhone?phone=${phone}`);
};

export const sendMessageApi = (data) => {
	return apiClient.post("/Chat/SendMessage", data);
};
